export const ENTITY_MAP = {
  1: 'Organization',
  2: 'Program',
};

export const ROLE_MAP = {
  1: 'Authorized Organization Representative',
  2: 'Organization Member',
  3: 'Program Administrator',
  4: 'Grants Management Specialist',
  5: 'Assistance Officer',
  6: 'Program Specialist',
  12: 'Panel Review Coordinator',
  13: 'EHP Administrator',
  14: 'EHP Reviewer',
  15: 'Grants Counsel Staff',
  16: 'Grants Counsel Administrator',
  17: 'Programmatic Member',
  18: 'Financial Member',
  19: 'Grant Writer',
  23: 'Panel Review Administrator',
  25: 'Analytics User',
  26: 'Analytics Admin',
  28: 'Senior Program Administrator',
};

export const PERMISSIONS_MAP = {
  'Program Administrator': `can grant and remove Program Specialist and Program Administrator role, has all privileges of the Program Specialist, and can see management dashboards.`,
  'Program Specialist': `conducts programmatic tasks.`,
  'Assistance Officer': `can grant the Grants Management Specialist and Assistance Officer roles, has all privileges of the Grants Management Specialist, and can see management dashboards.`,
  'Grants Management Specialist': `conducts grants management tasks.`,
  'Authorized Organization Representative': `can add or remove team members, and can submit your organization's closeout report to FEMA. The Authorized Organization Representative has all the permissions of Organization members.`,
  'Organization Member': `can view and edit all information in the system.`,
  'EHP Administrator': `can grant the EHP Reviewer and EHP Administrator role, has all privileges of the EHP Reviewer, and can see management dashboards.`,
  'EHP Reviewer': `conducts EHP tasks.`,
  'Grants Counsel Staff': `conducts Grant Counsel tasks.`,
  'Grants Counsel Administrator': `can grant the Grants Counsel Staff and Grants Counsel Administrator role, has all privileges of the Grant Counsel Staff, and can see management dashboards.`,
  'Programmatic Member':
    'can view and edit all information and can only submit amendments and programmatic reports.',
  'Financial Member':
    'can view and edit all information, and can only submit payments or draw down requests, financial reports, and amendments.',
  'Grant Writer':
    'can view and edit all information for an application or subapplication.',
  'Senior Program Administrator':
    'can grant and remove program specialist, program administrator, and senior program administrator roles, can see management dashboards and has all privileges of the Program Specialist and Program Administrator.',
};
export const PERMISSIONS_MAP_V2 = {
  ...PERMISSIONS_MAP,
  'Program Administrator': `can grant and remove Program Specialist and Program Administrator role, has all privileges of the Program Specialist, and can see management dashboards.`,
  'Program Specialist': `conducts programmatic tasks.`,
  'Assistance Officer': `can grant the Grants Management Specialist and Assistance Officer roles, has all privileges of the Grants Management Specialist, and can see management dashboards.`,
  'Grants Management specialist': `conducts grants management tasks.`,
  'EHP Administrator': `can grant the EHP Reviewer and EHP Administrator role, has all privileges of the EHP Reviewer, and can see management dashboards.`,
  'EHP Reviewer': `conducts EHP tasks.`,
  'Grants Counsel Staff': `conducts Grant Counsel tasks.`,
  'Grants Counsel Administrator': `can grant the Grants Counsel Staff and Grants Counsel Administrator role, has all privileges of the Grant Counsel Staff, and can see management dashboards.`,
  'Analytics Admin':
    'can add colleagues to their report category and has all privileges of the Analytics User',
  'Analytics User': 'can view and export reports from the reports page',
};
export const ROLE_TO_ROLES_MAP = {
  '3': ['3', '6'],
  '5': ['4', '5'],
  '1': ['1', '2', '17', '18', '19'],
  '13': ['13', '14'], // EHP roles
  '16': ['15', '16'], // OCC roles
  '23': ['23'], // panel review admin
  '26': ['25', '26'], //Analytics roles
  '28': ['3', '6', '28'], // Senior program admin
};
